// Single source of truth for all brand colors and styles
// This file is used to generate the variables.scss file
// if you are adding a new color or style, please add it here
// and run the generate-scss-variables.ts script to update the variables.scss file
// variable name should be in camelCase
// variable value should be in hex format
// variable description should be in camelCase
// variable description should be in camelCase

// Colors
export const BRAND_COLORS = {
  leoPrimary: '#3D8FEB',
  leoSecondary: '#7B7B7B',
  primary: '#3D8FEB',
  secondary: '#7B7B7B',
  secondaryLight: '#281350',
  accent: '#fdfc18', // Same as primary, adjust if needed
  purple: '#8755E9',
  content: '#6E7191',
  contentLight: '#C0B9CF',
  grayBorder: '#E2E2E2',
  chipBg: '#E2E2E2',
  // The subtle neutral border shared by form controls and the flat dashboard
  // chrome (same value as theme.ts CONTROL_BORDER_SUBTLE / antd's control border).
  controlBorderSubtle: 'rgba(159, 159, 159, 0.4)',
  info: '#3582FF',
  success: '#49BA61',
  successLight: '#e7ffe5',
  warning: '#FFB73A',
  danger: '#FE5938',
  dangerLight: '#E4E4E4',
  caution: '#ff832b',
  button: '#222222',
  black: '#121212',
  white: '#FDFDFD',
  whiteLight: '#FFFFFF',
  light100: '#F8F7F7',
  light200: '#F1F1F1',
  light300: '#EBEBEB',
  light400: '#E2E2E2',
  light500: '#BBBBC0',
  bodyText: '#121212',
  containerBg: '#F1F1F1',
  sidebarBg: '#0D0D0D',
  contentBg: '#F1F1F1',
  tableRowHover: '#3C076D',
  reactourAccent: '#290125',
} as const;

// Styles
export const BRAND_STYLES = {
  fontFamily: '"Manrope", sans-seri',
  tableRadius: '24px',
  borderRadius: {
    default: '24px',
    small: '8px',
    medium: '24px',
    large: '32px',
  },
  // Dashboard-header control heights: the bespoke house scale (antd's SM=24/MD=32
  // don't include 28), shared by the icon-button groups, pickers, and toggles.
  controlHeight: {
    default: '32px',
    small: '28px',
  },
} as const;
